import React from 'react'
import {FormLabel, FormControlLabel, RadioGroup, Radio} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

const FYesNoField = ({data, onChange = (e, key, value) => {}}) => {
  return (
    <>
      <FormLabel component="legend" style={{marginTop: 10}}>
        Default
      </FormLabel>
      <RadioGroup
        aria-label="default"
        name="default"
        value={data.default_value}
        onChange={e => onChange(e, 'default_value')}
        row
      >
        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="no" control={<Radio />} label="No" />
      </RadioGroup>
    </>
  )
}

export default FYesNoField
